import { render, staticRenderFns } from "./selectManagement.vue?vue&type=template&id=1fac5253"
import script from "./selectManagement.vue?vue&type=script&lang=js"
export * from "./selectManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports